import React from "react";
import axios from "axios";

export const confirmPayment = async (token,gateway,search) => {
  try {
    let url = `https://visapro-api.tcore.online/api/v1/confirm-transaction/${gateway}${search}`;

    const response = await axios.get(url,{
      headers: {
          'Authorization': `Bearer ${token}` 
        },
  });
    const confirm = {
      data: response.data,
    };
    return confirm;
  } catch (error) {
    const confirm = {
      error: error,
    };
    return confirm;
  }
};
